import { IPoint, MarkerBaseState, TextMarker } from '@markerjs/markerjs3';
import { wrapTextByWidth } from './MarkerHelpers';

export default class LSTextMarker extends TextMarker {
    private _background: SVGRectElement;
    private _textWidthContext: CanvasRenderingContext2D;

    constructor(container: SVGGElement) {
        super(container);

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        if (context) {
            this._textWidthContext = context;
        }

        const wrapText = ((this.textBlock as any).wrapText as Function).bind(this.textBlock);
        const newWrapText = () => {
            const wrappedText = wrapTextByWidth(
                this.text,
                this.fontSize.value,
                this.fontFamily,
                null,
                this._textWidthContext
            );

            return wrappedText;
        };

        // The text wrapping in MarkerJS does not work for wrapping text that gets too long on a single line, it only wraps text when the user adds a line break.
        // The function above measure the width of the text against a max width and add lines break when the text is longer than the max width.
        (this.textBlock as any).wrapText = newWrapText;
    }

    createVisual(): void {
        super.createVisual();
        this.addBackground();
        this.setBackgroundWidth();
        this.textBlock.fontFamily = `sans-serif`;
    }

    adjustVisual(): void {
        super.adjustVisual();
        this.setBackgroundWidth();
    }

    private addBackground() {
        this._background = document.createElementNS("http://www.w3.org/2000/svg", "rect");

        if (this._background && this.visual) {
            this._background.setAttribute("fill", "#ffffffaa");
            this._background.setAttribute("rx", "8");

            const text = this.visual.firstChild;
            this.visual.insertBefore(this._background, text);
        }
    }

    private setBackgroundWidth(): void {
        if (this._background) {
            const box: DOMRect = this.getBBox();
            this._background.setAttribute("width", `${box.width}`);
            this._background.setAttribute("height", `${box.height}`);
        }
    }

    restoreState(state: MarkerBaseState): void {
        super.restoreState(state);
        this.text = wrapTextByWidth(
            this.text,
            this.fontSize.value,
            this.fontFamily,
            null,
            this._textWidthContext
        );
    }

    /**
     * Disabling rotation due to weird textbox sizing behavior
     * @param point 
     */
    rotate(point: IPoint): void {

    }
}